import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { SupplierListDto } from '../../suppliers/dtos/supplier-list.dto';
import { VehicleListDto } from '../../vehicles/dtos/vehicle-list.dto';
import { VehicleInsuranceCoverageTypeEnum } from '../enums/vehicle-insurance-coverage-type.enum';
import { VehicleInsurancePremiumPeriodEnum } from '../enums/vehicle-insurance-premium-period.enum';
import { VehicleInsuranceRecordCategoryEnum } from '../enums/vehicle-insurance-record-category.enum';
import { VehicleInsuranceStatusEnum } from '../enums/vehicle-insurance-status.enum';

import { VehicleInsuranceLinksDto } from './vehicle-insurance-links.dto';

/**
 * Vehicle insurance DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_INSURANCE)
export class VehicleInsuranceListDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleInsuranceStatusEnum;
  recordCategory!: VehicleInsuranceRecordCategoryEnum;
  vehicle!: VehicleListDto;
  supplier?: SupplierListDto | null;
  insuredValue?: number | null;
  premiumPeriod!: VehicleInsurancePremiumPeriodEnum;
  excessAmount?: number | null;
  totalLossPercentage?: number | null;
  computedTotalLossAmountReceivable?: number | null;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  coverageType?: VehicleInsuranceCoverageTypeEnum | null;
  coverageDescription?: string | null;
  tags?: TagListDto[] | null;
  links?: VehicleInsuranceLinksDto | null;
}
